import { AssetInventory } from '../entities/asset-inventory';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class AssetInventoryRequest extends BaseRequest {
  
  assetInventory : AssetInventory;

  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.assetInventory = new AssetInventory();
  }

}